import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, NavigationExtras } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AdalService } from './../azure-authentication/adal.service';
import { UserService } from "../../users/user.service";

@Injectable()
export class AuthenticationGuard implements CanActivate {

    constructor(private router: Router,
        private adalService: AdalService,
        private userService: UserService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        let navigationExtras: NavigationExtras = {
            queryParams: { 'redirectUrl': route.url }
        };

        if (!this.adalService.userInfo) {
            this.router.navigate(['login'], navigationExtras);
        }

        if (this.adalService.userInfo && !this.userService.currentUser) {
            this.userService.setCurrentUser(this.adalService.userInfo.userName);
        }

        return true;
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/shared/azure-authentication/authentication.guard.ts